// extracted by mini-css-extract-plugin
export default {"img":"Bitstray_img__bIdl4","imgWrapper":"Bitstray_imgWrapper__vTFTs"};